var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 55 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 8.34734C37 5.39365 34.6149 3 31.6721 3H11.3283C8.38511 3 6 5.39365 6 8.34734V32.6527C6 35.6064 8.38511 38 11.3283 38H31.6721C34.6149 38 37 35.6064 37 32.6527V8.34734Z",
    fill: "#0066FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1954 31.6198C39.2257 36.1452 35.5671 39.8532 31.0417 39.8835L11.2448 40.0161L11.2675 43.396C11.2871 46.326 13.6842 48.6916 16.6143 48.672L42.6885 48.4972C45.6185 48.4776 47.984 46.0801 47.9644 43.1501L47.8026 19.0075C47.783 16.0775 45.3855 13.712 42.4555 13.7316L39.0756 13.7543L39.1954 31.6198Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.17671ea7a3356e006f88ef7a35dedc90.svg";
export { ForwardRef as ReactComponent };